// import React, { useEffect, useState } from 'react';
// import { rootUrl } from '../../App';

const TC = ({ from }) => {
    // const [termsConditions, setTermsConditions] = useState({});

    // console.log(from);

    // useEffect(() => {
    //     if (from) {
    //         fetch(`${rootUrl}${"/statics/page-content/"}`)
    //             .then(res => {
    //                 if (!res.ok) throw res;
    //                 else return res.json();
    //             })
    //             .then(data => {
    //                 if (data?.status === "ok") {
    //                     // console.log(data?.data[0]?.description);
    //                     setTermsConditions(data?.data[0]);
    //                 }
    //             })
    //     }

    // }, [from]);

    return (
        <>
            <div className="mx-2 my-2 pt-0"
            >
                <div className="row g-0 pt-2">
                    <div className="col-12">
                        <div className="" dangerouslySetInnerHTML={{ __html: from?.description }}>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TC;